export const POSTHOG_ANONYMOUS_ID_KEY = 'eluve-posthog-anonymous-id';
